import React from 'react';
import { useSearchParams } from 'react-router-dom';
import AnalysisPage from '../Analysis_Parsing_Pages/AnalysisPages';
import ParsingPage from '../Analysis_Parsing_Pages/ParsingPage';
import DatabaseAdmin from '../DatabaseAdmin/DatabaseAdmin';
import DictionariesAdmin from '../DatabaseAdmin/DictionariesAdmin';
import Stat from '../Main/Home';
import SourceData from '../Source_Data/Source_Data';
import ExportData from '../Export_Data/Export_Data';
import TableReportsBuilder from './TableReportsBuilder';
import PageTabs from '../components/PageTabs';
import SessionsMonitorAndAnalysis from '../Session_monitoring/SessionsMonitorAndAnalysis';
import { PAGE_KEYS } from '../utils/pageAccess';
import './Pages.scss';

function Admin({ allowedPages = [] }) {
  const [searchParams, setSearchParams] = useSearchParams();

  const tabs = [
    { id: 'collect', label: 'Сбор данных', page: PAGE_KEYS.PARSING },
    { id: 'analyze', label: 'Анализ данных', page: PAGE_KEYS.ANALYSIS },
    { id: 'settings', label: 'Настройки', page: PAGE_KEYS.DATABASE_ADMIN },
    { id: 'dictionaries', label: 'Словари', page: PAGE_KEYS.DICTIONARIES },
    { id: 'stat', label: 'Статистика', page: PAGE_KEYS.STATISTICS },
    { id: 'monitor', label: 'Мониторинг сессий', page: PAGE_KEYS.MONITORING },
    { id: 'source-data', label: 'Исходные данные', page: PAGE_KEYS.SOURCE_DATA },
    { id: 'export-data', label: 'Экспорт данных', page: PAGE_KEYS.EXPORT_DATA },
    { id: 'reports', label: 'Формирование отчётов', page: PAGE_KEYS.REPORTS }
  ];

  const filteredTabs = tabs.filter((tab) => allowedPages.includes(tab.page));
  const requestedTab = searchParams.get('tab');
  const activeTab = filteredTabs.some((tab) => tab.id === requestedTab)
    ? requestedTab
    : filteredTabs[0]?.id;
  const setActiveTab = (tabId) => setSearchParams({ tab: tabId });

  return filteredTabs.length > 0 ? (
    <div className="top-level-page-container">
      <div className="admin-page-tabs">
        <PageTabs activeTab={activeTab} setActiveTab={setActiveTab} tabs={filteredTabs} />
      </div>
      <div className="page-content">
        {activeTab === 'collect' && (
          <ParsingPage />
        )}
        {activeTab === 'analyze' && (
          <AnalysisPage />
        )}
        {activeTab === 'settings' && (
          <DatabaseAdmin />
        )}
        {activeTab === 'dictionaries' && (
          <DictionariesAdmin />
        )}
        {activeTab === 'stat' && (
          <Stat />
        )}
        {activeTab === 'monitor' && (
          <SessionsMonitorAndAnalysis />
        )}
        {activeTab === 'source-data' && (
          <SourceData />
        )}
        {activeTab === 'export-data' && (
          <ExportData />
        )}
        {activeTab === 'reports' && (
          <TableReportsBuilder />
        )}
      </div>
    </div>
  ) : (
    <div className="top-level-page-container">
      <h1>У вас нет доступа к разделам администрирования</h1>
    </div>
  );
}

export default Admin;
